/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EscrowCreatedEvent = {
  escrowId: bigint;
  client: Address;
  agent: Address;
  amount: bigint;
  deadline: bigint;
};

export type EscrowCreatedEventArgs = {
  escrowId: number | bigint;
  client: Address;
  agent: Address;
  amount: number | bigint;
  deadline: number | bigint;
};

export function getEscrowCreatedEventEncoder(): FixedSizeEncoder<EscrowCreatedEventArgs> {
  return getStructEncoder([
    ["escrowId", getU64Encoder()],
    ["client", getAddressEncoder()],
    ["agent", getAddressEncoder()],
    ["amount", getU64Encoder()],
    ["deadline", getI64Encoder()],
  ]);
}

export function getEscrowCreatedEventDecoder(): FixedSizeDecoder<EscrowCreatedEvent> {
  return getStructDecoder([
    ["escrowId", getU64Decoder()],
    ["client", getAddressDecoder()],
    ["agent", getAddressDecoder()],
    ["amount", getU64Decoder()],
    ["deadline", getI64Decoder()],
  ]);
}

export function getEscrowCreatedEventCodec(): FixedSizeCodec<
  EscrowCreatedEventArgs,
  EscrowCreatedEvent
> {
  return combineCodec(
    getEscrowCreatedEventEncoder(),
    getEscrowCreatedEventDecoder(),
  );
}
